import type {QuickFilterMeasureItem} from '@Module/Group/Component/QuickFilter/Types/QuickFilterMeasureItem';

declare global {
    interface Window {
        Measure?: {
            Manager?: {
                instance?: {
                    quickFilter(quickFilterMeasureItem: QuickFilterMeasureItem): Promise<void>;
                    cookiePermission(cookiePermission: string, eventName: string): Promise<void>;
                    namedEvent(name: string): void;
                };
            };
            CustomProperties: {
                setQuickFilterValue(value: string): void;
                setQuickFilterTotalPositions(value: number): void;
            };

            event(category: string, action: string, label?: string, value?: string | number, nonInteraction?: boolean): Promise<void>;
            register(): void;
        };
    }
}

export default class Measure {
    public static register(): void {
        if (window.Measure?.Manager?.instance !== undefined) {
            return;
        }
        window.Measure?.register();
    }

    public static isRegistered(): boolean {
        return window.Measure?.Manager?.instance !== undefined;
    }

    public static event(category: string, action: string, label?: string, value?: string | number, nonInteraction?: boolean): Promise<void> | void {
        return window.Measure?.event(category, action, label, value, nonInteraction);
    }

    public static quickFilter(quickFilterMeasureItem: QuickFilterMeasureItem): Promise<void> | void {
        return window.Measure?.Manager?.instance?.quickFilter(quickFilterMeasureItem);
    }

    public static cookiePermission(permission: boolean, updateConsent: boolean = true): Promise<void> | void {
        const eventName = permission ? 'cookiebanner_accept' : 'cookiebanner_deny';
        if (updateConsent) {
            return window.Measure?.Manager?.instance?.cookiePermission(permission ? 'granted' : 'denied', eventName);
        }

        return window.Measure?.Manager?.instance?.namedEvent(eventName);
    }

    public static setQuickFilterValue(value: string): void {
        return window.Measure?.CustomProperties.setQuickFilterValue(value);
    }

    public static setQuickFilterTotalPositions(value: number): void {
        return window.Measure?.CustomProperties.setQuickFilterTotalPositions(value);
    }
}
